import React from 'react';
import { X } from 'lucide-react';
import { Badge } from '../ui/badge';

export const ActiveFilterChips = ({
  selectedManufacturers,
  selectedTypes,
  searchQuery,
  onRemoveManufacturer,
  onRemoveType,
  onClearSearch,
  onClearAll,
}) => {
  const hasFilters = selectedManufacturers.length > 0 || selectedTypes.length > 0 || searchQuery;

  if (!hasFilters) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6">
      <span className="text-sm text-muted-foreground">Active filters:</span>
      
      {searchQuery && (
        <Badge
          variant="secondary"
          className="gap-1 cursor-pointer hover:bg-destructive hover:text-destructive-foreground transition-colors"
          onClick={onClearSearch}
        >
          Search: {searchQuery}
          <X className="w-3 h-3" />
        </Badge>
      )}
      
      {selectedManufacturers.map((manufacturer) => (
        <Badge
          key={manufacturer}
          variant="secondary"
          className="gap-1 cursor-pointer hover:bg-destructive hover:text-destructive-foreground transition-colors"
          onClick={() => onRemoveManufacturer(manufacturer)}
        >
          {manufacturer}
          <X className="w-3 h-3" />
        </Badge>
      ))}
      
      {selectedTypes.map((type) => (
        <Badge
          key={type}
          variant="secondary"
          className="gap-1 cursor-pointer hover:bg-destructive hover:text-destructive-foreground transition-colors"
          onClick={() => onRemoveType(type)}
        >
          {type}
          <X className="w-3 h-3" />
        </Badge>
      ))}
      
      {(selectedManufacturers.length + selectedTypes.length + (searchQuery ? 1 : 0)) > 1 && (
        <button
          onClick={onClearAll}
          className="text-sm text-destructive hover:underline"
        >
          Clear all
        </button>
      )}
    </div>
  );
};
